'use client'

import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import Header from '@/components/Header'
import CopilotaWidget from '@/components/CopilotaWidget'

// /welcome aggiunta qui: è lo splash di benvenuto (nome, slogan, concorso),
// niente Header né Copilota, esattamente come le pagine di autenticazione.
const AUTH_ROUTES = ['/login', '/signup', '/auth/callback', '/auth/reset-password', '/welcome']

// Pagine in condizioni d'esame: niente Copilota. Decisione confermata
// indipendentemente dal Suggeritore (che per la v1.0 non si fa).
const ROUTE_SENZA_BOT = ['/simulazione']

export default function ConditionalAppShell() {
  const [isApp, setIsApp] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    const hostname = window.location.hostname
    setIsApp(hostname === 'app.3940.it' || hostname === 'localhost')
  }, [])

  if (!isApp) return null
  if (AUTH_ROUTES.some(route => pathname.startsWith(route))) return null

  const nessunBot = ROUTE_SENZA_BOT.some(route => pathname.startsWith(route))

  return (
    <>
      <Header />
      {!nessunBot && <CopilotaWidget />}
    </>
  )
}